import React, { useContext, useEffect, useState } from 'react';
import store from '../../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { AlertContext, Alert_, CardsForty, CardsSixty, Confirmation_, Google_Search, Grey_Link, On_Click_Card, PageAlwaysVisible, PageDesktopOnly, PageDesktopPadding, PageIllu, PageSixty, PageSubtitle, PageTitle, Section_Search, Sixty_Card_Loader } from 'monica-alexandria';
import { Helmet } from 'react-helmet';
import i18n from '../../../../localization/i18next';
import { t } from 'i18next';
import { AuthContext } from '../../../../services/authentication/Guard';
import { checkOwnership } from '../../../../helpers/verifyToolOwnership';
import { deleteReport, getReports } from '../../services/api/Report';
import { prettifyDates } from '../../../../helpers/prettifiers';

const environment = process.env.REACT_APP_SERVER;


export default function REPORTS() {

    store.dispatch({type: "SAVE_GOOGLE_REPORT", payload: {}}); // Drop stored report from localStorage

    const lang = i18n.language ? i18n.language : 'en';
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const userId = auth?.user?.sub;

    /* LocalStorage data */
    const GoogleSourceData = store.getState().googleSource;
    const client = GoogleSourceData.clientAccount;

    /* For tool ownership validation */
    const [hasCheckOwnership, setHasCheckOwnership] = useState(false);

    /* For deleting report */
    const [reportDelete, setReportDelete] = useState(false);

    const [reports, setReports] = useState([]);

    /* Something for monica */
    const [selectedReportId, setSelectedReportId] = useState(false);

    /* Alerts */ 
    const { alerts, setAlerts } = useContext(AlertContext);

    const alertMessage = (message, status) => {
        setAlerts([
            ...alerts,
            {
                message: {
                    text: message,
                    status: status,
                },
            },
        ]);
    };

    /* Switch data assignment ( Real/Dummy ) */
    const initActions = () => {
       getReports(client.name)
        .then((res) => {
            console.log('res',res);
            if ( res.data.data.reports ) {
                setReports(res.data.data.reports)
            } 
        }).catch(err=>{console.error(err); alertMessage("Something went wrong", "Error")})
    }

    const handleNavigation = (route) => {
        navigate(`/${lang}/${route}`);
    }


    /* Also something for monica */
    const handleViewOptions = (report) =>{
        setSelectedReportId((prevSelectedId) =>
            prevSelectedId === report._id ? false : report._id
        );
    }

    const handleDeleteReport = () => {
        setReportDelete(selectedReportId)
    }

    const delete_report = () => {
        deleteReport(selectedReportId)
        .then((response) => {
            setReportDelete(false)
            setReports((prevData) => (prevData.filter((report) => report._id !== reportDelete)));
        })
        .catch((error) => {
            alertMessage((t('Error deleting report, Please try again later...')), 'Error');
            setReportDelete(false)
        });
    }

    useEffect(() => {
        initActions();
    },[])

    /* Validate Tool Ownership */
    useEffect(() => {
        if (userId) checkOwnership(userId, navigate, lang, setHasCheckOwnership);
    }, [userId]);

    return (
        <>
        <Helmet>
            <title>Adsnap | Accounts</title>
        </Helmet>
        <Alert_ messages={alerts} />
            {hasCheckOwnership && (
                <PageSixty>
                    {reportDelete && 
                    <Confirmation_
                        message={t("Are you sure you want to delete your report?")}
                        no={t("No")}
                        onNo={() => setReportDelete(false)}
                        onYes={delete_report}
                        yes={t("Yes")}
                    />
                    }
                    <PageAlwaysVisible>
                        <PageTitle>
                            <Grey_Link 
                                iconLeft="Back" 
                                id={"AdSnap_Google_Reports_1"} 
                                onClick={() => navigate(`/${lang}/google/accounts`)} 
                                noPadding 
                            />
                            <h1>{client.name} reports</h1>
                        </PageTitle>
                        <CardsSixty>
                            {reports.length > 0 &&
                                reports.map((report) => {
                                    const isSelected = selectedReportId === report._id;
                                    return <On_Click_Card 
                                            icon="Report" 
                                            isOptions = {isSelected}
                                            edit={"Edit"}
                                            onView = {() => {handleNavigation(`google/report/${report._id}`)}}
                                            onCLickEdit={true}
                                            onEdit={() => {handleNavigation(`google/create-report/${report._id}`)}}
                                            options
                                            onDelete = {() => handleDeleteReport()}
                                            delete="Delete"
                                            view="View"
                                            onLoadImg={function noRefCheck(){}}
                                            subtitle={ report?.title ? report?.title : prettifyDates(report?.createdAt)} 
                                            id={"AdSnap_Google_Reports_2"}             
                                            onClick={() => handleViewOptions(report)} />;
                            })}
                        </CardsSixty>
                    </PageAlwaysVisible>
                    <PageAlwaysVisible>
                        <PageDesktopPadding>
                            <CardsForty>
                                <On_Click_Card 
                                    icon="AddPlan" 
                                    title={t('New report')} 
                                    id={"AdSnap_Google_Reports_3"} 
                                    onClick={() => handleNavigation(environment === 'LOCAL' ? 'google/source-account' : 'google/connect')} 
                                />
                            </CardsForty>
                        </PageDesktopPadding>
                    </PageAlwaysVisible>
                </PageSixty>
            )}
        </>
    );
}